import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import {
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  InputAdornment,
} from "@material-ui/core";

import { matchSorter } from "match-sorter";

import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialog: {
    minWidth: 600,
  },
  dialogHeaderContainer: {
    display: "flex",
    paddingRight: 30,
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    height: 500,
    padding: theme.shape.padding * 2,
  },
  headerCtaContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    "& p": {
      marginBottom: 0,
      paddingRight: theme.shape.padding,
    },
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
  },
  searchTextFieldContainer: {
    paddingTop: theme.shape.padding * 2,
    paddingLeft: theme.shape.padding * 2,
  },
  searchTextField: {
    marginTop: -theme.shape.padding,
    marginBottom: theme.shape.padding,
  },
  link: {
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
  close: {
    cursor: "pointer",
  },
  clickable: {
    cursor: "pointer",
  },
}));

export const SearchableListDialog = (props) => {
  const classes = useStyles();

  const [searchText, setSearchText] = useState("");
  const [viewingItems, setViewingItems] = useState(props.items);

  useEffect(() => {
    setViewingItems(props.items);
  }, [props.items]);

  const handleSearch = (event) => {
    setSearchText(event.target.value);

    const propToSearch = props.searchableProperty
      ? props.searchableProperty
      : "name";

    if (event.target.value) {
      setViewingItems(
        matchSorter(props.items, event.target.value, { keys: [propToSearch] })
      );
    } else setViewingItems(props.items);
  };

  const handleItemClick = (itemId) => {
    if (!props.onItemClick) return;

    // reset search text
    setSearchText("");

    // handle item click and close
    props.onItemClick(itemId);
    props.onClose();
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <div className={classes.dialog}>
        <div className={classes.dialogHeaderContainer}>
          <DialogTitle>{props.title}</DialogTitle>
          <div className={classes.headerCtaContainer}>
            {!!props.handleAdditionalInfoClick && (
              <p
                className={classes.link}
                onClick={props.handleAdditionalInfoClick}
              >
                {props.additionalInfo}
              </p>
            )}
            <CloseIcon className={classes.close} onClick={props.onClose} />
          </div>
        </div>
        {props.items && props.items.length > 0 ? (
          <div className={classes.searchTextFieldContainer}>
            <TextField
              autoFocus
              label={"Search"}
              value={searchText}
              onChange={handleSearch}
              className={classes.searchTextField}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              data-cy={"searchableListDialogInput"}
            />
          </div>
        ) : null}
        <DialogContent className={classes.dialogContent}>
          <div className={classes.itemContainer}>
            {viewingItems.length === 0 ? (
              <p style={{ textAlign: "center" }}>
                {props.emptyText ? props.emptyText : "No items found."}
              </p>
            ) : (
              viewingItems.map((item, index) => (
                <p
                  key={index}
                  onClick={() => handleItemClick(item.id)}
                  className={props.onItemClick ? classes.clickable : null}
                  data-cy={"selectOrgItem"}
                >
                  {props.searchableProperty
                    ? item[props.searchableProperty]
                    : item.name}
                </p>
              ))
            )}
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
};

SearchableListDialog.defaultProps = {
  items: [],
  additionalInfo: "",
};

export default connect(null, null)(SearchableListDialog);
